module.exports = __webpack_public_path__ + "static/img/bank.724b110.png";